import React from 'react';
import './Luau.css';
import { Helmet } from 'react-helmet';

function Luau() {
  return (
    <div className="fade-in">
      {/* Set the page title in the browser tab */}
      <Helmet>
        <title>Lū'au - Hui Hoaloha Ulana</title>
      </Helmet>

      <div className="container">
        {/* Hero image and title */}
        <div className="luau-image">
          <img src="/images/luau.jpg" alt="Luau Banner" />
          <div className="hero-text content-wrapper">
            <h1 className="title">Lū'au</h1>
            <p className="luau-description">
              Our annual Lū'au blends the culture of our island home, delicious food,
              bright entertainment, and unforgettable memories all in one spectacular event.
              Keep an eye out in March for the official announcement!
            </p>
          </div>
        </div>

        {/* Info Section: Parents/Sponsors & Students */}
        <div className="info-columns">
          {/* Parent/Sponsor Info */}
          <div className="info-column">
            <h2>For Parents/Sponsors</h2>
            <ul>
              <li>
                📧 To donate money or become a sponsor, contact us at
                <a href="mailto:ohanauw@uw.edu"> ohanauw@uw.edu</a>
              </li>
              <li>
                📍 The event will be held at the Husky Union Building Ballroom. Parking
                details will be announced in May.
              </li>
              <li>
                🎟️ Ticket sales will start in March — both online and in-person.
              </li>
              {/* Optional: Replace above with live ticket links and price info when available */}
            </ul>
          </div>

          {/* Student Info */}
          <div className="info-column">
            <h2>For Students</h2>
            <ul>
              <li>
                🎟️ Get free admission by joining 2 committees: Country Store, Dance,
                Decoration, Food, Ticketing, or Publicity.
              </li>
              <li>
                📝 Luau is on May 16, 2026. If you wish to get involved in any capacity then you can email Luau Logistics Chair Sarah Tottori at stottori@uw.edu
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Luau;
